"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrainerUpload = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const trainer_types_1 = require("../../types/trainer.types");
const events_1 = require("@front/components/form-parts/events");
const backendImport_1 = require("@front/backendImport");
const events_2 = require("../../events");
const FileProcessingService_1 = __importStar(require("../../services/FileProcessingService"));
const ValidationService_1 = __importStar(require("../../services/ValidationService"));
const ManualDataService_1 = __importStar(require("../../services/ManualDataService"));
const PdfChapterService_1 = __importStar(require("../../services/PdfChapterService"));
const PdfManagementService_1 = __importStar(require("../../services/PdfManagementService"));
const helpers_1 = require("./helpers");
//@ts-ignore                
let rwsTemplate = T.html `<div class="upload-section">
  
  <div class="mode-selector">
    <h2 class="mt-3">📚 ${'trainer.upload.mode.title'.t()}</h2>
    <div class="mode-buttons">
      <button 
        class="mode-button${x => x.uploadMode === 'pdf' ? ' active' : ''}" 
        @click="${x => x.switchMode('pdf')}">
        📖 PDF Training Generator
      </button>
      <button 
        class="mode-button${x => x.uploadMode === 'file' ? ' active' : ''}" 
        @click="${x => x.switchMode('file')}">
        📄 ${'trainer.upload.mode.file'.t()}
      </button> 
      <button 
        class="mode-button${x => x.uploadMode === 'manual' ? ' active' : ''}"         
        @click="${x => x.switchMode('manual')}">
        ✏️ ${'trainer.upload.mode.manual'.t()}
      </button>
    </div>
    <p class="mode-description">
      ${x => x.uploadMode === 'file' ? 'trainer.upload.mode.file.description'.t() :
    x.uploadMode === 'pdf' ? 'Upload a PDF document to automatically generate training data by extracting chapters and creating question-answer pairs.' :
        'trainer.upload.mode.manual.description'.t()}
    </p>
  </div>

  
  <div class="upload-area p-3" ?hidden="${x => x.uploadMode !== 'file'}">
    <div class="upload-instructions">
      <h3>📄 ${'trainer.upload.title'.t()}</h3>
      <p><strong>${'trainer.upload.format.required'.t()}</strong></p>
      <ul>
        <li><code>input</code> - ${'trainer.upload.format.input'.t()}</li>
        <li><code>output</code> - ${'trainer.upload.format.output'.t()}</li>
        <li><code>category</code> (${'trainer.upload.format.optional'.t()}) - ${'trainer.upload.format.category'.t()}</li>
      </ul>
      <p><em>${'trainer.upload.format.metadata'.t()}</em></p>
    </div>
    
    <div class="file-input-container">      
      <part-file-upload 
        name="training-file"
        label="${'trainer.upload.select'.t()}"
        accept=".csv"
        placeholder="${'trainer.upload.select'.t()}"        
        ?disabled="${x => x.isFileLoading}">
      </part-file-upload>
      
      
      <div class="upload-loading" ?hidden="${x => !x.isFileLoading}">
        <div class="loading-spinner"></div>
        <span>${'trainer.upload.processing'.t()}</span>
      </div>
    </div>
  </div>

  
  <div class="pdf-upload-area p-3" ?hidden="${x => x.uploadMode !== 'pdf'}">
    <div class="pdf-upload-instructions">
      <h3>📖 PDF Training Data Generator</h3>
      <p><strong>Upload a PDF document to automatically generate training data</strong></p>
      <p>The system will:</p>
      <ul>
        <li>Extract text from your PDF document</li>
        <li>Split content into logical chapters/sections</li>
        <li>Generate question-answer pairs for each chapter</li>
        <li>Create comprehensive training data automatically</li>
      </ul>
    </div>
    
    <div class="pdf-file-input-container">      
      <part-file-upload 
        name="pdf-file"
        label="Select PDF Document"
        accept=".pdf"
        placeholder="Choose a PDF file to generate training data"        
        ?disabled="${x => x.isPdfLoading}">
      </part-file-upload>
      
      
      <div class="pdf-upload-loading" ?hidden="${x => !x.isPdfLoading}">
        <div class="loading-spinner-area">
          <app-loader></app-loader>
        </div>
        <span>Processing PDF and generating training data...</span>
      </div>
    </div>

    
    <div class="pdf-context-section" ?hidden="${x => !x.selectedPdfFile || 1 == 1}">
      <div class="form-group">
        <part-textarea 
          class="form-part"
          label="Document Context (Optional)"
          :value="${x => x.pdfContext}"
          name="pdf-context"
          placeholder="Provide additional context about this document (e.g., 'Software development guide', 'Medical procedures manual', etc.)"
          rows="2">
        </part-textarea>
        <small class="context-help">
          Adding context helps generate more relevant and targeted training questions.
        </small>
      </div>
    </div>

    
    <div class="chapter-selection" ?hidden="${x => !x.showChapterSelection}">
      <div class="chapter-header mb-3">
        <h4>📑 Extracted Chapters (${x => x.pdfChapters.length})</h4>
        <div class="chapter-actions">
          <button class="btn btn-secondary select-all-btn" @click="${x => x.selectAllChapters()}">
            Select All
          </button>
          <button class="btn btn-secondary deselect-all-btn" @click="${x => x.deselectAllChapters()}">
            Deselect All
          </button>
        </div>
      </div>
      
      <div class="chapters-list">
        ${(0, fast_element_1.repeat)(x => x.pdfChapters, (0, fast_element_1.html) `
        <div class="chapter-item">
          <label class="chapter-checkbox">
            <input 
              type="checkbox" 
              :checked="${(x, c) => c.parent.selectedChapters.has(c.index)}"
              @change="${(x, c) => c.parent.toggleChapterSelection(c.index)}">
            <div class="chapter-content">
              <h5 class="chapter-title">${x => x.title}</h5>
              <p class="chapter-summary">${x => x.summary}</p>
              <small class="chapter-page-range">
                Pages: ${x => x.startPage}-${x => x.endPage} (${x => x.pageCount} pages)
              </small>
            </div>
          </label>
        </div>
        `)}
      </div>
      
      <div class="generate-actions mt-3">
        <button 
          class="btn btn-primary generate-btn" 
          @click="${x => x.generateFromSelectedChapters()}"
          ?disabled="${x => x.selectedChapters.size === 0 || x.isPdfLoading}">
          🎯 Generate Training Data from Selected Chapters (${x => x.selectedChapters.size})
        </button>
      </div>
    </div>
  </div>

  
  <div class="manual-entry-area" ?hidden="${x => x.uploadMode !== 'manual'}">
    <div class="manual-form">
      <h3>✏️ ${'trainer.upload.manual.title'.t()}</h3>
      <p class="manual-description">${'trainer.upload.manual.description'.t()}</p>
      
      <the-form>
        <div class="form-grid">
          <div class="form-group">
            <part-textarea 
              class="form-part"
              label="${'trainer.upload.manual.input'.t()}"
              :value="${x => x.currentEntry.input}"
              name="input"
              placeholder="${'trainer.upload.manual.input.placeholder'.t()}"
              rows="3"
              required="true">
            </part-textarea>
          </div>

          <div class="form-group">
            <part-textarea 
              class="form-part"
              label="${'trainer.upload.manual.output'.t()}"
              :value="${x => x.currentEntry.output}"
              name="output"
              placeholder="${'trainer.upload.manual.output.placeholder'.t()}"
              rows="3"
              required="true">
            </part-textarea>
          </div>

          <div class="form-group">
            <part-input 
              class="form-part"
              label="${'trainer.upload.manual.category'.t()}"
              :value="${x => x.currentEntry.category}"
              name="category"
              type="text"
              placeholder="${'trainer.upload.manual.category.placeholder'.t()}">
            </part-input>
          </div>
        </div>

        <div class="form-actions">
          <button 
            class="add-button" 
            @click="${x => x.addManualEntry()}"
            ?disabled="${x => !x.currentEntry.input.trim() || !x.currentEntry.output.trim()}">
            ${x => x.isEditingIndex >= 0 ? 'trainer.upload.manual.update'.t() : 'trainer.upload.manual.add'.t()}
          </button>
          <button 
            class="cancel-button" 
            @click="${x => x.resetManualForm}"
            ?hidden="${x => x.isEditingIndex < 0}">
            ${'trainer.upload.manual.cancel'.t()}
          </button>
        </div>
      </the-form>
    </div>

    
    <div class="manual-data-list" ?hidden="${x => x.manualData.length === 0}">
      <div class="list-header">
        <h4>${'trainer.upload.manual.list.title'.t()} (${x => x.manualData.length})</h4>
        <button class="export-button" @click="${x => x.exportManualData}">
          💾 ${'trainer.upload.manual.export'.t()}
        </button>
      </div>
      
      <div class="data-entries">
        ${(0, fast_element_1.repeat)(x => x.manualData, (0, fast_element_1.html) `
        <div class="data-entry">
          <div class="entry-content">
            <div class="entry-field">
              <strong>${'trainer.upload.manual.input'.t()}:</strong>
              <span class="field-content">${x => x.input}</span>
            </div>
            <div class="entry-field">
              <strong>${'trainer.upload.manual.output'.t()}:</strong>
              <span class="field-content">${x => x.output}</span>
            </div>
            <div class="entry-field" ?hidden="${x => !x.category}">
              <strong>${'trainer.upload.manual.category'.t()}:</strong>
              <span class="field-content">${x => x.category}</span>
            </div>
          </div>
          <div class="entry-actions">
            <button class="edit-button" @click="${(x, c) => c.parent.editManualEntry(c.index)}">
              ✏️ ${'trainer.upload.manual.edit'.t()}
            </button>
            <button class="delete-button" @click="${(x, c) => c.parent.removeManualEntry(c.index)}">
              🗑️ ${'trainer.upload.manual.delete'.t()}
            </button>
          </div>
        </div>
        `)}
      </div>
    </div>
  </div>

  
  <div class="file-info" ?hidden="${x => (!x.selectedFile && !x.selectedPdfFile) || (x.uploadMode !== 'file' && x.uploadMode !== 'pdf')}">
    <h3>📋 File Information</h3>
    <div class="info-grid">
      <div class="info-item">
        <label>File Name</label>
        <span>${x => { var _a, _b; return x.uploadMode === 'pdf' ? (((_a = x.selectedPdfFile) === null || _a === void 0 ? void 0 : _a.filename) || '') : (((_b = x.selectedFile) === null || _b === void 0 ? void 0 : _b.filename) || ''); }}</span>
      </div>
      <div class="info-item">
        <label>File Size</label>
        <span>${x => {
    const file = x.uploadMode === 'pdf' ? x.selectedPdfFile : x.selectedFile;
    return file ? (file.size / 1024 / 1024).toFixed(2) + ' MB' : '';
}}</span>
      </div>
      <div class="info-item">
        <label>File Type</label>
        <span>${x => { var _a; return x.uploadMode === 'pdf' ? 'application/pdf' : (((_a = x.selectedFile) === null || _a === void 0 ? void 0 : _a.mimeType) || 'text/csv'); }}</span>
      </div>
      <div class="info-item" ?hidden="${x => x.uploadMode !== 'pdf' || x.pdfChapters.length === 0}">
        <label>Chapters Extracted</label>
        <span>${x => x.pdfChapters.length}</span>
      </div>
    </div>
  </div>

  
  <div class="data-statistics p-3" ?hidden="${x => !x.validationResult && x.manualData.length === 0 && x.generatedFromPdf.length === 0}">
    <h3>📊 ${'trainer.upload.data.analysis'.t()}</h3>
    <div class="stats-grid">
      <div class="stat-card">
        <div class="stat-value">${x => x.dataStatistics.totalSamples}</div>
        <div class="stat-label">${'trainer.upload.stats.samples'.t()}</div>
      </div>
      <div class="stat-card">
        <div class="stat-value">${x => x.dataStatistics.averageInputLength}</div>
        <div class="stat-label">${'trainer.upload.stats.input.length'.t()}</div>
      </div>
      <div class="stat-card">
        <div class="stat-value">${x => x.dataStatistics.averageOutputLength}</div>
        <div class="stat-label">${'trainer.upload.stats.output.length'.t()}</div>
      </div>
      <div class="stat-card">
        <div class="stat-value">${x => x.dataStatistics.categories.length}</div>
        <div class="stat-label">${'trainer.upload.stats.categories'.t()}</div>
      </div>
      <div class="stat-card">
        <div class="stat-value">${x => x.dataStatistics.qualityScore}%</div>
        <div class="stat-label">${'trainer.upload.stats.quality'.t()}</div>
      </div>
    </div>
    
    <div class="categories-list p-3" ?hidden="${x => x.dataStatistics.categories.length === 0}">
      <h4>${'trainer.upload.categories.found'.t()}</h4>
      <div class="category-tags">
        ${(0, fast_element_1.repeat)(x => x.dataStatistics.categories, (0, fast_element_1.html) `
          <span class="category-tag">${x => x}</span>
        `)}        
      </div>
    </div>
  </div>

  
  <div class="data-preview mb-3" ?hidden="${x => x.parsedData.length === 0 && x.manualData.length === 0 && x.generatedFromPdf.length === 0}">
    <h3 class="p-3">👀 ${'trainer.upload.preview'.t()}</h3>
    <div class="table-container">
      <table class="preview-table">
        <thead>
          <tr>
            <th>${'trainer.upload.preview.input'.t()}</th>
            <th>${'trainer.upload.preview.output'.t()}</th>
            <th>${'trainer.upload.preview.category'.t()}</th>
          </tr>
        </thead>
        <tbody>
          <tr ?hidden="${x => (x.uploadMode === 'file' ? x.parsedData : x.uploadMode === 'pdf' ? x.generatedFromPdf : x.manualData).length < 1}">
            <td class="input-cell">${x => { var _a, _b; return ((_a = (x.uploadMode === 'file' ? x.parsedData : x.uploadMode === 'pdf' ? x.generatedFromPdf : x.manualData)[0]) === null || _a === void 0 ? void 0 : _a.input.substring(0, 100)) + (((_b = (x.uploadMode === 'file' ? x.parsedData : x.uploadMode === 'pdf' ? x.generatedFromPdf : x.manualData)[0]) === null || _b === void 0 ? void 0 : _b.input.length) > 100 ? '...' : ''); }}</td>
            <td class="output-cell">${x => { var _a, _b; return ((_a = (x.uploadMode === 'file' ? x.parsedData : x.uploadMode === 'pdf' ? x.generatedFromPdf : x.manualData)[0]) === null || _a === void 0 ? void 0 : _a.output.substring(0, 100)) + (((_b = (x.uploadMode === 'file' ? x.parsedData : x.uploadMode === 'pdf' ? x.generatedFromPdf : x.manualData)[0]) === null || _b === void 0 ? void 0 : _b.output.length) > 100 ? '...' : ''); }}</td>
            <td class="category-cell">${x => { var _a; return ((_a = (x.uploadMode === 'file' ? x.parsedData : x.uploadMode === 'pdf' ? x.generatedFromPdf : x.manualData)[0]) === null || _a === void 0 ? void 0 : _a.category) || '-'; }}</td>
          </tr>
          <tr ?hidden="${x => (x.uploadMode === 'file' ? x.parsedData : x.uploadMode === 'pdf' ? x.generatedFromPdf : x.manualData).length < 2}">
            <td class="input-cell">${x => { var _a, _b; return ((_a = (x.uploadMode === 'file' ? x.parsedData : x.uploadMode === 'pdf' ? x.generatedFromPdf : x.manualData)[1]) === null || _a === void 0 ? void 0 : _a.input.substring(0, 100)) + (((_b = (x.uploadMode === 'file' ? x.parsedData : x.uploadMode === 'pdf' ? x.generatedFromPdf : x.manualData)[1]) === null || _b === void 0 ? void 0 : _b.input.length) > 100 ? '...' : ''); }}</td>
            <td class="output-cell">${x => { var _a, _b; return ((_a = (x.uploadMode === 'file' ? x.parsedData : x.uploadMode === 'pdf' ? x.generatedFromPdf : x.manualData)[1]) === null || _a === void 0 ? void 0 : _a.output.substring(0, 100)) + (((_b = (x.uploadMode === 'file' ? x.parsedData : x.uploadMode === 'pdf' ? x.generatedFromPdf : x.manualData)[1]) === null || _b === void 0 ? void 0 : _b.output.length) > 100 ? '...' : ''); }}</td>
            <td class="category-cell">${x => { var _a; return ((_a = (x.uploadMode === 'file' ? x.parsedData : x.uploadMode === 'pdf' ? x.generatedFromPdf : x.manualData)[1]) === null || _a === void 0 ? void 0 : _a.category) || '-'; }}</td>
          </tr>
          <tr ?hidden="${x => (x.uploadMode === 'file' ? x.parsedData : x.uploadMode === 'pdf' ? x.generatedFromPdf : x.manualData).length < 3}">
            <td class="input-cell">${x => { var _a, _b; return ((_a = (x.uploadMode === 'file' ? x.parsedData : x.uploadMode === 'pdf' ? x.generatedFromPdf : x.manualData)[2]) === null || _a === void 0 ? void 0 : _a.input.substring(0, 100)) + (((_b = (x.uploadMode === 'file' ? x.parsedData : x.uploadMode === 'pdf' ? x.generatedFromPdf : x.manualData)[2]) === null || _b === void 0 ? void 0 : _b.input.length) > 100 ? '...' : ''); }}</td>
            <td class="output-cell">${x => { var _a, _b; return ((_a = (x.uploadMode === 'file' ? x.parsedData : x.uploadMode === 'pdf' ? x.generatedFromPdf : x.manualData)[2]) === null || _a === void 0 ? void 0 : _a.output.substring(0, 100)) + (((_b = (x.uploadMode === 'file' ? x.parsedData : x.uploadMode === 'pdf' ? x.generatedFromPdf : x.manualData)[2]) === null || _b === void 0 ? void 0 : _b.output.length) > 100 ? '...' : ''); }}</td>
            <td class="category-cell">${x => { var _a; return ((_a = (x.uploadMode === 'file' ? x.parsedData : x.uploadMode === 'pdf' ? x.generatedFromPdf : x.manualData)[2]) === null || _a === void 0 ? void 0 : _a.category) || '-'; }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    ${(0, fast_element_1.when)(x => x.parsedData.length, (0, fast_element_1.html) `<div class="go-next mt-3">
      <button 
        class="btn btn-primary next-button" 
        @click="${x => x.goNext()}">
        ${'trainer.tab.config'.t()} ➡️
      </button>
    </div>`)}
  </div>
</div>
`;
require("./styles/layout.scss");
const styles = T.css `:host {
  display: block;
  width: 100%;
}

.upload-section .mode-selector {
  margin-bottom: 2rem;
  text-align: center;
}
.upload-section .mode-selector h2 {
  color: #1e293b;
  margin: 0 0 1rem 0;
}
.upload-section .mode-selector .mode-buttons {
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-bottom: 1rem;
}
.upload-section .mode-selector .mode-buttons .mode-button {
  padding: 0.75rem 1.5rem;
  border: 2px solid #e2e8f0;
  background: white;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.3s ease;
  color: #64748b;
}
.upload-section .mode-selector .mode-buttons .mode-button:hover {
  border-color: #cbd5e1;
  background: #f8fafc;
}
.upload-section .mode-selector .mode-buttons .mode-button.active {
  border-color: #667eea;
  background: #667eea;
  color: white;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
}
.upload-section .mode-selector .mode-description {
  color: #64748b;
  font-size: 0.9rem;
  margin: 0;
}
.upload-section .upload-area {
  margin-bottom: 2rem;
}
.upload-section .upload-area .upload-instructions {
  background: #f8fafc;
  padding: 1.5rem;
  border-radius: 8px;
  margin-bottom: 1.5rem;
  border: 2px dashed #cbd5e1;
}
.upload-section .upload-area .upload-instructions h3 {
  color: #1e293b;
  margin: 0 0 1rem 0;
}
.upload-section .upload-area .upload-instructions ul {
  margin: 0.5rem 0;
  padding-left: 1.5rem;
}
.upload-section .upload-area .upload-instructions ul li {
  margin-bottom: 0.5rem;
  color: #475569;
}
.upload-section .upload-area .upload-instructions ul li code {
  background: #e2e8f0;
  padding: 0.2rem 0.4rem;
  border-radius: 4px;
  font-family: "Monaco", "Menlo", monospace;
  font-size: 0.9rem;
}
.upload-section .upload-area .file-input-container {
  text-align: center;
}
.upload-section .upload-area .file-input-container part-file-upload {
  --file-upload-button-background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  --file-upload-button-color: white;
  --file-upload-button-border-radius: 8px;
  --file-upload-button-padding: 1rem 2rem;
  --file-upload-button-font-weight: 600;
  --file-upload-button-font-size: 1.1rem;
  --file-upload-button-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
  --file-upload-button-hover-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
  --file-upload-button-hover-transform: translateY(-2px);
  display: block;
  width: 100%;
  max-width: 400px;
  margin: 0 auto;
}
.upload-section .upload-area .file-input-container .upload-loading {
  margin-top: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  color: #667eea;
  font-weight: 600;
}
.upload-section .upload-area .file-input-container .upload-loading .loading-spinner {
  width: 20px;
  height: 20px;
  border: 2px solid rgba(102, 126, 234, 0.2);
  border-top-color: #667eea;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}
.upload-section .upload-area .file-input-container ::part(file-upload) {
  display: none;
}
.upload-section .upload-area .file-input-container #csv-file {
  display: none;
}
.upload-section .upload-area .file-input-container ::part(file-upload-label),
.upload-section .upload-area .file-input-container .file-input-label {
  display: inline-block;
  padding: 1rem 2rem;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 600;
  font-size: 1.1rem;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
}
.upload-section .upload-area .file-input-container ::part(file-upload-label):hover,
.upload-section .upload-area .file-input-container .file-input-label:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
}
.upload-section .upload-area .file-input-container ::part(file-upload-label) .loading-spinner,
.upload-section .upload-area .file-input-container .file-input-label .loading-spinner {
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 2px solid rgba(255, 255, 255, 0.2);
  border-top-color: white;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-right: 0.5rem;
}
.upload-section .chapter-selection {
  margin-bottom: 2rem;
}
.upload-section .chapter-selection .chapter-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  padding: 1rem;
  background: #f1f5f9;
  border-radius: 8px;
  border: 2px solid #e2e8f0;
}
.upload-section .chapter-selection .chapter-header h4 {
  color: #1e293b;
  margin: 0;
  font-size: 1.1rem;
  font-weight: 600;
}
.upload-section .chapter-selection .chapter-header .chapter-actions {
  display: flex;
  gap: 0.5rem;
}
.upload-section .chapter-selection .chapters-list {
  display: grid;
  gap: 1rem;
  margin-bottom: 1.5rem;
}
.upload-section .chapter-selection .chapters-list .chapter-item {
  background: white;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  transition: all 0.3s ease;
  overflow: hidden;
}
.upload-section .chapter-selection .chapters-list .chapter-item:hover {
  border-color: #cbd5e1;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transform: translateY(-1px);
}
.upload-section .chapter-selection .chapters-list .chapter-item .chapter-checkbox {
  display: flex;
  align-items: flex-start;
  padding: 1.25rem;
  cursor: pointer;
  margin: 0;
  gap: 1rem;
}
.upload-section .chapter-selection .chapters-list .chapter-item .chapter-checkbox input[type=checkbox] {
  margin: 0;
  transform: scale(1.2);
  accent-color: #667eea;
  cursor: pointer;
  flex-shrink: 0;
  margin-top: 0.25rem;
}
.upload-section .chapter-selection .chapters-list .chapter-item .chapter-checkbox .chapter-content {
  flex: 1;
}
.upload-section .chapter-selection .chapters-list .chapter-item .chapter-checkbox .chapter-content .chapter-title {
  margin: 0 0 0.5rem 0;
  color: #1e293b;
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.3;
}
.upload-section .chapter-selection .chapters-list .chapter-item .chapter-checkbox .chapter-content .chapter-summary {
  margin: 0 0 0.75rem 0;
  color: #64748b;
  font-size: 0.9rem;
  line-height: 1.4;
}
.upload-section .chapter-selection .chapters-list .chapter-item .chapter-checkbox .chapter-content .chapter-page-range {
  display: inline-block;
  background: #e0e7ff;
  color: #3730a3;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  font-size: 0.8rem;
  font-weight: 500;
}
.upload-section .chapter-selection .chapters-list .chapter-item .chapter-checkbox:hover .chapter-content .chapter-title {
  color: #667eea;
}
.upload-section .chapter-selection .chapters-list .chapter-item:has(input[type=checkbox]:checked) {
  border-color: #667eea;
  background: #f8fafc;
}
.upload-section .chapter-selection .chapters-list .chapter-item:has(input[type=checkbox]:checked) .chapter-checkbox .chapter-content .chapter-title {
  color: #667eea;
}
.upload-section .chapter-selection .chapters-list .chapter-item:has(input[type=checkbox]:checked) .chapter-checkbox .chapter-content .chapter-page-range {
  background: #667eea;
  color: white;
}
.upload-section .chapter-selection .generate-actions {
  text-align: center;
}
.upload-section .manual-entry-area {
  margin-bottom: 2rem;
}
.upload-section .manual-entry-area .manual-form {
  background: #f8fafc;
  padding: 1.5rem;
  border-radius: 8px;
  border: 2px solid #e2e8f0;
  margin-bottom: 1.5rem;
}
.upload-section .manual-entry-area .manual-form h3 {
  color: #1e293b;
  margin: 0 0 0.5rem 0;
}
.upload-section .manual-entry-area .manual-form .manual-description {
  color: #64748b;
  margin: 0 0 1.5rem 0;
  font-size: 0.9rem;
}
.upload-section .manual-entry-area .manual-form .form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto auto auto;
  gap: 1rem;
  margin-bottom: 1.5rem;
}
.upload-section .manual-entry-area .manual-form .form-grid .form-group {
  display: flex;
  flex-direction: column;
}
.upload-section .manual-entry-area .manual-form .form-grid .form-group:last-child {
  grid-column: 1/-1;
}
.upload-section .manual-entry-area .manual-form .form-grid .form-group label {
  color: #374151;
  font-weight: 600;
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
}
.upload-section .manual-entry-area .manual-form .form-grid .form-group textarea, .upload-section .manual-entry-area .manual-form .form-grid .form-group input {
  padding: 0.75rem;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 0.9rem;
  transition: border-color 0.2s ease;
}
.upload-section .manual-entry-area .manual-form .form-grid .form-group textarea:focus, .upload-section .manual-entry-area .manual-form .form-grid .form-group input:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}
.upload-section .manual-entry-area .manual-form .form-grid .form-group textarea::placeholder, .upload-section .manual-entry-area .manual-form .form-grid .form-group input::placeholder {
  color: #9ca3af;
}
.upload-section .manual-entry-area .manual-form .form-grid .form-group textarea {
  resize: vertical;
  min-height: 80px;
  font-family: inherit;
}
.upload-section .manual-entry-area .manual-form .form-actions {
  display: flex;
  gap: 0.75rem;
}
.upload-section .manual-entry-area .manual-form .form-actions .add-button {
  padding: 0.75rem 1.5rem;
  background: #10b981;
  color: white;
  border: none;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}
.upload-section .manual-entry-area .manual-form .form-actions .add-button:hover {
  background: #059669;
  transform: translateY(-1px);
}
.upload-section .manual-entry-area .manual-form .form-actions .add-button:disabled {
  background: #d1d5db;
  cursor: not-allowed;
  transform: none;
}
.upload-section .manual-entry-area .manual-form .form-actions .cancel-button {
  padding: 0.75rem 1.5rem;
  background: #6b7280;
  color: white;
  border: none;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}
.upload-section .manual-entry-area .manual-form .form-actions .cancel-button:hover {
  background: #4b5563;
  transform: translateY(-1px);
}
.upload-section .manual-entry-area .manual-data-list .list-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}
.upload-section .manual-entry-area .manual-data-list .list-header h4 {
  color: #1e293b;
  margin: 0;
}
.upload-section .manual-entry-area .manual-data-list .list-header .export-button {
  padding: 0.5rem 1rem;
  background: #667eea;
  color: white;
  border: none;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  font-size: 0.9rem;
  transition: all 0.2s ease;
}
.upload-section .manual-entry-area .manual-data-list .list-header .export-button:hover {
  background: #5a67d8;
  transform: translateY(-1px);
}
.upload-section .manual-entry-area .manual-data-list .data-entries .data-entry {
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 1rem;
  margin-bottom: 0.75rem;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
.upload-section .manual-entry-area .manual-data-list .data-entries .data-entry .entry-content {
  flex: 1;
}
.upload-section .manual-entry-area .manual-data-list .data-entries .data-entry .entry-content .entry-field {
  margin-bottom: 0.5rem;
}
.upload-section .manual-entry-area .manual-data-list .data-entries .data-entry .entry-content .entry-field:last-child {
  margin-bottom: 0;
}
.upload-section .manual-entry-area .manual-data-list .data-entries .data-entry .entry-content .entry-field strong {
  color: #374151;
  font-size: 0.85rem;
  display: inline-block;
  min-width: 80px;
}
.upload-section .manual-entry-area .manual-data-list .data-entries .data-entry .entry-content .entry-field .field-content {
  color: #6b7280;
  font-size: 0.9rem;
  display: block;
  margin-top: 0.25rem;
  max-width: 500px;
  word-wrap: break-word;
}
.upload-section .manual-entry-area .manual-data-list .data-entries .data-entry .entry-actions {
  display: flex;
  gap: 0.5rem;
  margin-left: 1rem;
}
.upload-section .manual-entry-area .manual-data-list .data-entries .data-entry .entry-actions .edit-button, .upload-section .manual-entry-area .manual-data-list .data-entries .data-entry .entry-actions .delete-button {
  padding: 0.4rem 0.8rem;
  border: none;
  border-radius: 4px;
  font-size: 0.8rem;
  cursor: pointer;
  transition: all 0.2s ease;
}
.upload-section .manual-entry-area .manual-data-list .data-entries .data-entry .entry-actions .edit-button:hover, .upload-section .manual-entry-area .manual-data-list .data-entries .data-entry .entry-actions .delete-button:hover {
  transform: translateY(-1px);
}
.upload-section .manual-entry-area .manual-data-list .data-entries .data-entry .entry-actions .edit-button {
  background: #f59e0b;
  color: white;
}
.upload-section .manual-entry-area .manual-data-list .data-entries .data-entry .entry-actions .edit-button:hover {
  background: #d97706;
}
.upload-section .manual-entry-area .manual-data-list .data-entries .data-entry .entry-actions .delete-button {
  background: #ef4444;
  color: white;
}
.upload-section .manual-entry-area .manual-data-list .data-entries .data-entry .entry-actions .delete-button:hover {
  background: #dc2626;
}
.upload-section .file-info {
  background: #f1f5f9;
  padding: 1.5rem;
  border-radius: 8px;
  margin-bottom: 1.5rem;
}
.upload-section .file-info h3 {
  margin: 0 0 1rem 0;
  color: #334155;
}
.upload-section .file-info .info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
}
.upload-section .file-info .info-grid .info-item {
  display: flex;
  flex-direction: column;
}
.upload-section .file-info .info-grid .info-item label {
  font-weight: 600;
  color: #64748b;
  margin-bottom: 0.25rem;
}
.upload-section .file-info .info-grid .info-item span {
  color: #334155;
  font-family: "Monaco", "Menlo", monospace;
}
.upload-section .data-statistics {
  margin-bottom: 1.5rem;
}
.upload-section .data-statistics h3 {
  margin: 0 0 1rem 0;
  color: #334155;
}
.upload-section .data-statistics .stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 1rem;
  margin-bottom: 1.5rem;
}
.upload-section .data-statistics .stats-grid .stat-card {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 1.5rem;
  border-radius: 8px;
  text-align: center;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.2);
}
.upload-section .data-statistics .stats-grid .stat-card .stat-value {
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
}
.upload-section .data-statistics .stats-grid .stat-card .stat-label {
  font-size: 0.9rem;
  opacity: 0.9;
}
.upload-section .data-statistics .categories-list h4 {
  margin: 0 0 0.5rem 0;
  color: #334155;
}
.upload-section .data-statistics .categories-list .category-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}
.upload-section .data-statistics .categories-list .category-tags .category-tag {
  background: #e2e8f0;
  padding: 0.3rem 0.8rem;
  border-radius: 20px;
  font-size: 0.9rem;
  color: #475569;
  font-weight: 500;
}
.upload-section .data-preview h3 {
  margin: 0 0 1rem 0;
  color: #334155;
}
.upload-section .data-preview .table-container {
  overflow-x: auto;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}
.upload-section .data-preview .table-container .preview-table {
  width: 100%;
  border-collapse: collapse;
  background: white;
}
.upload-section .data-preview .table-container .preview-table th {
  background: #f1f5f9;
  padding: 1rem;
  text-align: left;
  font-weight: 600;
  color: #334155;
  border-bottom: 2px solid #e2e8f0;
}
.upload-section .data-preview .table-container .preview-table td {
  padding: 1rem;
  border-bottom: 1px solid #e2e8f0;
  color: #475569;
  max-width: 300px;
  word-wrap: break-word;
}
.upload-section .data-preview .table-container .preview-table td.input-cell, .upload-section .data-preview .table-container .preview-table td.output-cell {
  font-family: "Monaco", "Menlo", monospace;
  font-size: 0.9rem;
}
.upload-section .data-preview .table-container .preview-table td.category-cell {
  font-weight: 500;
}
.upload-section .data-preview .table-container .preview-table tr:hover {
  background: #f8fafc;
}

.message-container {
  margin-bottom: 1.5rem;
  padding: 1rem 1.5rem;
  border-radius: 8px;
  border-left: 4px solid;
}
.message-container.error {
  background: #fef2f2;
  border-color: #ef4444;
  color: #991b1b;
}
.message-container.error h3 {
  color: #dc2626;
  margin: 0 0 0.5rem 0;
}
.message-container.warning {
  background: #fffbeb;
  border-color: #f59e0b;
  color: #92400e;
}
.message-container.warning h3 {
  color: #d97706;
  margin: 0 0 0.5rem 0;
}
.message-container ul {
  margin: 0;
  padding-left: 1.5rem;
}
.message-container ul li {
  margin-bottom: 0.25rem;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
@media (max-width: 768px) {
  .upload-section .mode-selector .mode-buttons {
    flex-direction: column;
    gap: 0.5rem;
  }
  .upload-section .mode-selector .mode-buttons .mode-button {
    width: 100%;
  }
  .upload-section .manual-entry-area .manual-form {
    padding: 1rem;
  }
  .upload-section .manual-entry-area .manual-form .form-grid {
    grid-template-columns: 1fr;
    gap: 0.75rem;
  }
  .upload-section .manual-entry-area .manual-form .form-grid .form-group:last-child {
    grid-column: 1;
  }
  .upload-section .manual-entry-area .manual-form .form-actions {
    flex-direction: column;
  }
  .upload-section .manual-entry-area .manual-form .form-actions .add-button, .upload-section .manual-entry-area .manual-form .form-actions .cancel-button {
    width: 100%;
  }
  .upload-section .manual-entry-area .manual-data-list .list-header {
    flex-direction: column;
    gap: 0.75rem;
    align-items: stretch;
  }
  .upload-section .manual-entry-area .manual-data-list .list-header .export-button {
    width: 100%;
  }
  .upload-section .manual-entry-area .manual-data-list .data-entry {
    flex-direction: column;
    gap: 1rem;
  }
  .upload-section .manual-entry-area .manual-data-list .data-entry .entry-actions {
    margin-left: 0;
    justify-content: center;
  }
  .upload-section .manual-entry-area .manual-data-list .data-entry .entry-actions .edit-button, .upload-section .manual-entry-area .manual-data-list .data-entry .entry-actions .delete-button {
    flex: 1;
  }
  .upload-section .data-statistics .stats-grid {
    grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  }
  .upload-section .data-preview .preview-table {
    font-size: 0.8rem;
  }
  .upload-section .data-preview .preview-table th, .upload-section .data-preview .preview-table td {
    padding: 0.5rem;
  }
}
@media (max-width: 480px) {
  .upload-section .manual-entry-area .manual-form {
    padding: 0.75rem;
  }
  .upload-section .manual-entry-area .manual-form .form-grid {
    gap: 0.5rem;
  }
  .upload-section .manual-entry-area .manual-data-list .data-entry {
    padding: 0.75rem;
  }
  .upload-section .manual-entry-area .manual-data-list .data-entry .entry-content .entry-field .field-content {
    font-size: 0.8rem;
    max-width: 100%;
  }
  .upload-section .manual-entry-area .manual-data-list .data-entry .entry-actions {
    gap: 0.25rem;
  }
  .upload-section .manual-entry-area .manual-data-list .data-entry .entry-actions .edit-button, .upload-section .manual-entry-area .manual-data-list .data-entry .entry-actions .delete-button {
    padding: 0.3rem 0.6rem;
    font-size: 0.7rem;
  }
}`;
const shadowOptions = { "mode": "open" };
let TrainerUpload = class TrainerUpload extends client_1.RWSViewComponent {
    constructor(fileProcessingService, validationService, manualDataService, pdfChapterService, pdfManagementService) {
        super();
        this.fileProcessingService = fileProcessingService;
        this.validationService = validationService;
        this.manualDataService = manualDataService;
        this.pdfChapterService = pdfChapterService;
        this.pdfManagementService = pdfManagementService;
        this.selectedFile = null;
        this.isFileLoading = false;
        this.parsedData = [];
        this.validationResult = null;
        this.dataStatistics = helpers_1.FileUploadHelper.createDefaultDataStatistics();
        this.uploadMode = 'pdf';
        this.manualData = [];
        this.currentEntry = helpers_1.StateManagementHelper.createEmptyEntry();
        this.isEditingIndex = -1;
        this.selectedPdfFile = null;
        this.isPdfLoading = false;
        this.pdfChapters = [];
        this.showChapterSelection = false;
        this.selectedChapters = new Set();
        this.pdfContext = '';
        this.generatedFromPdf = [];
        this.pdfFileName = null;
    }
    connectedCallback() {
        super.connectedCallback();
        this.currentEntry = helpers_1.StateManagementHelper.createEmptyEntry();
        this.on(events_1.inputEvents.changed, (event) => {
            const result = helpers_1.EventHandlingHelper.handleInputEvent(event.detail, this.currentEntry, this.handleFileUpload.bind(this), this.handlePdfUpload.bind(this), (context) => { this.pdfContext = context; });
            if (result.shouldUpdateEntry && result.updatedEntry) {
                this.currentEntry = result.updatedEntry;
            }
        });
    }
    // Mode switching
    switchMode(mode) {
        this.uploadMode = mode;
        const resetFlags = helpers_1.StateManagementHelper.handleModeSwitch(mode);
        if (resetFlags.shouldResetManual) {
            this.resetManualForm();
        }
        else if (resetFlags.shouldResetPdf) {
            this.resetPdfState();
        }
    }
    // Manual form methods
    createEmptyEntry() {
        return helpers_1.StateManagementHelper.createEmptyEntry();
    }
    resetManualForm() {
        const reset = helpers_1.StateManagementHelper.resetManualData();
        this.currentEntry = reset.currentEntry;
        this.isEditingIndex = reset.isEditingIndex;
    }
    addManualEntry() {
        const result = helpers_1.ManualDataHelper.validateAndAddEntry(this.currentEntry, this.manualData, this.isEditingIndex, this.manualDataService, this.emit.bind(this));
        if (result.success && result.updatedData) {
            this.manualData = result.updatedData;
            this.isEditingIndex = result.updatedIndex || -1;
            this.resetManualForm();
            this.updateManualDataStatistics();
        }
    }
    editManualEntry(index) {
        this.currentEntry = { ...this.manualData[index] };
        this.isEditingIndex = index;
    }
    removeManualEntry(index) {
        const result = helpers_1.ManualDataHelper.removeEntry(this.manualData, index, this.isEditingIndex, this.manualDataService);
        this.manualData = result.updatedData;
        this.isEditingIndex = result.updatedEditingIndex;
        this.updateManualDataStatistics();
    }
    duplicateManualEntry(index) {
        this.manualData = helpers_1.ManualDataHelper.duplicateEntry(this.manualData, index, this.manualDataService);
        this.updateManualDataStatistics();
    }
    importTemplate(template) {
        this.manualData = helpers_1.ManualDataHelper.importTemplate(this.manualData, template, this.manualDataService);
        this.updateManualDataStatistics();
    }
    updateManualDataStatistics() {
        const result = helpers_1.ManualDataHelper.updateStatisticsAndEmit(this.manualData, this.validationService, this.emit.bind(this));
        this.dataStatistics = result.statistics;
        this.validationResult = result.validation;
    }
    exportManualData() {
        helpers_1.ManualDataHelper.exportData(this.manualData, this.fileProcessingService, this.emit.bind(this));
    }
    async handleFileUpload(file) {
        console.log('File upload initiated:', file);
        if (!file) {
            this.resetFileState();
            return;
        }
        const validation = helpers_1.FileUploadHelper.validateCsvFile(file);
        if (!validation.isValid) {
            this.emit(events_2.trainerEvents.uploadError, { error: validation.error });
            this.resetFileInput();
            return;
        }
        this.selectedFile = file;
        this.isFileLoading = true;
        this.resetManualData();
        try {
            const result = await helpers_1.FileUploadHelper.processFileUpload(file, this.fileProcessingService, this.validationService);
            this.parsedData = result.data;
            this.validationResult = result.validation;
            this.dataStatistics = result.statistics;
            helpers_1.FileUploadHelper.emitFileUploadEvents(this.emit.bind(this), file, result.data, result.validation, result.statistics);
            // Also emit fileUploaded event for consistency with regular file uploads
            this.emit(events_2.trainerEvents.fileUploaded, {
                file: this.selectedPdfFile,
                data: result.data,
                validation: result.validation,
                statistics: result.statistics
            });
        }
        catch (error) {
            console.error('Error processing file:', error);
            this.emit(events_2.trainerEvents.uploadError, {
                error: error.message || 'Failed to process the uploaded file'
            });
            this.resetFileState();
            this.resetFileInput();
        }
        finally {
            this.isFileLoading = false;
        }
    }
    resetFileState() {
        const reset = helpers_1.StateManagementHelper.resetFileState();
        this.selectedFile = reset.selectedFile;
        this.parsedData = reset.parsedData;
        this.validationResult = reset.validationResult;
        this.dataStatistics = reset.dataStatistics;
    }
    resetFileInput() {
        helpers_1.StateManagementHelper.resetFileInput(this);
    }
    resetManualData() {
        const reset = helpers_1.StateManagementHelper.resetManualData();
        this.manualData = reset.manualData;
        this.resetManualForm();
    }
    // PDF processing methods
    async handlePdfUpload(file) {
        console.log('PDF file upload initiated:', file);
        if (!file) {
            this.resetPdfState();
            return;
        }
        const validation = this.pdfManagementService.validatePdfFile(file);
        if (!validation.isValid) {
            helpers_1.PdfProcessingHelper.emitPdfEvents('error', this.emit.bind(this), { error: validation.error });
            return;
        }
        this.selectedPdfFile = file;
        this.isPdfLoading = true;
        this.resetFileState();
        this.resetManualData();
        try {
            const result = await helpers_1.PdfProcessingHelper.processPdfUpload(file, this.pdfManagementService, this.pdfChapterService);
            this.pdfChapters = result.chapters;
            this.showChapterSelection = true;
            this.selectedChapters = result.selectedChapters;
            this.pdfFileName = result.fileName;
            helpers_1.PdfProcessingHelper.emitPdfEvents('success', this.emit.bind(this), {
                message: `Successfully extracted ${this.pdfChapters.length} chapters from ${file.filename}`
            });
        }
        catch (error) {
            console.error('Error processing PDF:', error);
            helpers_1.PdfProcessingHelper.emitPdfEvents('error', this.emit.bind(this), {
                error: error.message || 'Failed to process the uploaded PDF file'
            });
            this.resetPdfState();
        }
        finally {
            this.isPdfLoading = false;
        }
    }
    toggleChapterSelection(index) {
        this.selectedChapters = helpers_1.PdfProcessingHelper.updateChapterSelection('toggle', index, this.pdfChapters, this.pdfChapterService);
    }
    selectAllChapters() {
        this.selectedChapters = helpers_1.PdfProcessingHelper.updateChapterSelection('selectAll', undefined, this.pdfChapters, this.pdfChapterService);
    }
    deselectAllChapters() {
        this.selectedChapters = helpers_1.PdfProcessingHelper.updateChapterSelection('deselectAll', undefined, this.pdfChapters, this.pdfChapterService);
    }
    async generateTrainingDataFromPdf() {
        const error = helpers_1.PdfProcessingHelper.validatePdfSelections(this.selectedChapters, this.selectedPdfFile);
        if (error) {
            helpers_1.PdfProcessingHelper.emitPdfEvents('error', this.emit.bind(this), { error });
            return;
        }
        this.isPdfLoading = true;
        try {
            const result = await helpers_1.PdfProcessingHelper.generateTrainingDataFromPdf(this.selectedPdfFile, this.pdfContext, this.pdfManagementService, this.validationService);
            this.generatedFromPdf = result.trainingData;
            this.validationResult = result.validation;
            this.dataStatistics = result.statistics;
            helpers_1.PdfProcessingHelper.emitPdfEvents('dataUploaded', this.emit.bind(this), {
                file: this.selectedPdfFile,
                trainingData: result.trainingData,
                validation: result.validation,
                statistics: result.statistics
            });
            helpers_1.PdfProcessingHelper.emitPdfEvents('success', this.emit.bind(this), {
                message: `Successfully generated ${this.generatedFromPdf.length} training samples from PDF`
            });
        }
        catch (error) {
            console.error('Error generating training data from PDF:', error);
            helpers_1.PdfProcessingHelper.emitPdfEvents('error', this.emit.bind(this), {
                error: error.message || 'Failed to generate training data from PDF'
            });
        }
        finally {
            this.isPdfLoading = false;
        }
    }
    async generateFromSelectedChapters() {
        const error = helpers_1.PdfProcessingHelper.validatePdfSelections(this.selectedChapters, this.selectedPdfFile);
        if (error) {
            helpers_1.PdfProcessingHelper.emitPdfEvents('error', this.emit.bind(this), { error });
            return;
        }
        this.isPdfLoading = true;
        try {
            const result = await helpers_1.PdfProcessingHelper.generateTrainingDataFromSelectedChapters(this.selectedChapters, this.pdfChapters, this.pdfContext, this.pdfFileName, this.pdfManagementService, this.validationService);
            this.generatedFromPdf = result.trainingData;
            this.validationResult = result.validation;
            this.dataStatistics = result.statistics;
            helpers_1.PdfProcessingHelper.emitPdfEvents('dataUploaded', this.emit.bind(this), {
                file: this.selectedPdfFile,
                trainingData: result.trainingData,
                validation: result.validation,
                statistics: result.statistics
            });
            // Also emit fileUploaded event for consistency with regular file uploads
            this.emit(events_2.trainerEvents.fileUploaded, {
                file: this.selectedPdfFile,
                data: result.trainingData,
                validation: result.validation,
                statistics: result.statistics
            });
            helpers_1.PdfProcessingHelper.emitPdfEvents('success', this.emit.bind(this), {
                message: `Successfully generated ${this.generatedFromPdf.length} training samples from ${this.selectedChapters.size} chapters`
            });
        }
        catch (error) {
            console.error('Error generating training data from chapters:', error);
            helpers_1.PdfProcessingHelper.emitPdfEvents('error', this.emit.bind(this), {
                error: error.message || 'Failed to generate training data from selected chapters'
            });
        }
        finally {
            this.isPdfLoading = false;
        }
    }
    goNext() {
        this.emit(events_2.trainerEvents.activeTabSet, 'config');
    }
    resetPdfState() {
        const reset = helpers_1.StateManagementHelper.resetPdfState();
        this.selectedPdfFile = reset.selectedPdfFile;
        this.pdfChapters = reset.pdfChapters;
        this.showChapterSelection = reset.showChapterSelection;
        this.pdfContext = reset.pdfContext;
        this.generatedFromPdf = reset.generatedFromPdf;
        this.isPdfLoading = reset.isPdfLoading;
        this.selectedChapters = reset.selectedChapters;
        this.pdfChapterService.resetChapterSelection();
    }
    emit(eventName, detail) {
        this.$emit(eventName, detail);
    }
};
exports.TrainerUpload = TrainerUpload;
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_f = typeof backendImport_1.IFile !== "undefined" && backendImport_1.IFile) === "function" ? _f : Object)
], TrainerUpload.prototype, "selectedFile", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], TrainerUpload.prototype, "isFileLoading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], TrainerUpload.prototype, "parsedData", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_g = typeof trainer_types_1.ValidationResult !== "undefined" && trainer_types_1.ValidationResult) === "function" ? _g : Object)
], TrainerUpload.prototype, "validationResult", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_h = typeof trainer_types_1.DataStatistics !== "undefined" && trainer_types_1.DataStatistics) === "function" ? _h : Object)
], TrainerUpload.prototype, "dataStatistics", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], TrainerUpload.prototype, "uploadMode", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], TrainerUpload.prototype, "manualData", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_j = typeof trainer_types_1.TrainingData !== "undefined" && trainer_types_1.TrainingData) === "function" ? _j : Object)
], TrainerUpload.prototype, "currentEntry", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], TrainerUpload.prototype, "isEditingIndex", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_k = typeof backendImport_1.IFile !== "undefined" && backendImport_1.IFile) === "function" ? _k : Object)
], TrainerUpload.prototype, "selectedPdfFile", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], TrainerUpload.prototype, "isPdfLoading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], TrainerUpload.prototype, "pdfChapters", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], TrainerUpload.prototype, "showChapterSelection", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_l = typeof Set !== "undefined" && Set) === "function" ? _l : Object)
], TrainerUpload.prototype, "selectedChapters", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], TrainerUpload.prototype, "pdfContext", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], TrainerUpload.prototype, "generatedFromPdf", void 0);
exports.TrainerUpload = TrainerUpload = __decorate([
    (0, client_1.RWSView)('trainer-upload', null, { template: rwsTemplate, styles, options: { shadowOptions } }),
    __param(0, (0, client_1.RWSInject)(FileProcessingService_1.default)),
    __param(1, (0, client_1.RWSInject)(ValidationService_1.default)),
    __param(2, (0, client_1.RWSInject)(ManualDataService_1.default)),
    __param(3, (0, client_1.RWSInject)(PdfChapterService_1.default)),
    __param(4, (0, client_1.RWSInject)(PdfManagementService_1.default)),
    __metadata("design:paramtypes", [typeof (_a = typeof FileProcessingService_1.FileProcessingServiceInstance !== "undefined" && FileProcessingService_1.FileProcessingServiceInstance) === "function" ? _a : Object, typeof (_b = typeof ValidationService_1.ValidationServiceInstance !== "undefined" && ValidationService_1.ValidationServiceInstance) === "function" ? _b : Object, typeof (_c = typeof ManualDataService_1.ManualDataServiceInstance !== "undefined" && ManualDataService_1.ManualDataServiceInstance) === "function" ? _c : Object, typeof (_d = typeof PdfChapterService_1.PdfChapterServiceInstance !== "undefined" && PdfChapterService_1.PdfChapterServiceInstance) === "function" ? _d : Object, typeof (_e = typeof PdfManagementService_1.PdfManagementServiceInstance !== "undefined" && PdfManagementService_1.PdfManagementServiceInstance) === "function" ? _e : Object])
], TrainerUpload);
TrainerUpload.defineComponent();
